import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export const useWatchInput = ({ initialValue, id }) => {
  if (!id) return undefined;
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    const inputToWatch = document.getElementById(id);
    let observer;
    if (!inputToWatch) {
      // This allows the hook to work even if the input to watch is not rendered when the page is
      observer = new MutationObserver(() => {
        const inputToWatch = document.getElementById(id);
        if (inputToWatch) {
          setValue(inputToWatch.value);
          inputToWatch.addEventListener("change", function () {
            setValue(this.value);
          });
          observer.disconnect(); // Stop observing once found
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      setValue(inputToWatch.value);
      inputToWatch.addEventListener("change", function () {
        setValue(this.value);
      });
    }
    return () => observer && observer.disconnect();
  }, []);

  return value;
};

useWatchInput.propTypes = {
  initialValue: PropTypes.any,
  id: PropTypes.string
};
